import {SHOW_MODAL} from '../action-creators/create-comp-info';
import {CLOSE_MODAL} from '../action-creators/create-comp-info';

const createCompInfoReducer = (state = {modValue:false},action) => {
    console.log(action.type)
       switch(action.type){
           case SHOW_MODAL:
              console.log(`${SHOW_MODAL} reducerss state:${JSON.stringify(state)} payload:${JSON.stringify(action.payload)}`);
               return action.payload; 
          case CLOSE_MODAL:
               console.log(`${CLOSE_MODAL} reducerss state:${JSON.stringify(state)} payload:${JSON.stringify(action.payload)}`);
               return action.payload;         
           default:
               console.log(`${CLOSE_MODAL} reducer state:${JSON.stringify(state)}`);
               return state;          
          }
  }
export default createCompInfoReducer;